import React from 'react';
import { formatNumber } from '../utils/formatNumber';
import styles from './metricScorecard.module.css';

interface MetricScorecardProps {
  label: string;
  value: number | string;
  subtitle?: string;
  variant?: 'navy' | 'orange';
}

const MetricScorecard: React.FC<MetricScorecardProps> = ({ label, value, subtitle, variant = 'navy' }) => (
  <div className={`${styles.card} ${variant === 'orange' ? styles.cardOrange : ''}`}>
    <p></p>
    <p className={styles.label}>{label}</p>
    <p className={styles.value}>
      {typeof value === 'number' ? formatNumber(value) : value}
    </p>
    {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
    <p></p>
  </div>
);

export default MetricScorecard;
